<template lang="html">
  <vue-date-picker
    class="datepicker"
    type="datetime"
    format="MM-dd-YYYY HH:mm:ss"
    v-model="model"
    lang="en"
  />
</template>

<script>
import VueDatePicker from 'vue2-datepicker';

export default {
  components: {
    VueDatePicker,
  },

  props: {
    value: [String, Date, Object],
  },

  data() {
    return {
      model: this.value,
    };
  },

  watch: {
    value(value) {
      this.model = value;
    },

    model(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss">
  .datepicker {
    input.mx-input {
      @include input;
    }
  }
</style>
